import {Controller} from '@hotwired/stimulus';

export default class StageSelectorController extends Controller {
    static targets = ['scrollRegion', 'scrollContent'];

    connect() {
        this.updateScrollState = this.updateScrollState.bind(this);
        this.revealActiveStage();
        this.scrollContentTarget.addEventListener('scroll', this.updateScrollState, {passive: true});
        window.addEventListener('resize', this.updateScrollState);
        this.updateScrollState();
    }

    disconnect() {
        this.scrollContentTarget.removeEventListener('scroll', this.updateScrollState);
        window.removeEventListener('resize', this.updateScrollState);
    }

    revealActiveStage() {
        const activeStage = this.scrollContentTarget.querySelector('li.active');
        if (!activeStage) return;

        const content = this.scrollContentTarget;
        const left = activeStage.offsetLeft;
        const right = left + activeStage.offsetWidth;
        const visibleLeft = content.scrollLeft;
        const visibleRight = visibleLeft + content.clientWidth;

        if (left < visibleLeft) {
            content.scrollLeft = left;
        } else if (right > visibleRight) {
            content.scrollLeft = right - content.clientWidth;
        }
    }

    updateScrollState() {
        const content = this.scrollContentTarget;
        const hasOverflow = content.scrollWidth > content.clientWidth;
        const hasLeftContent = content.scrollLeft > 0;
        const hasRightContent = content.scrollLeft + content.clientWidth < content.scrollWidth - 1;

        this.scrollRegionTarget.classList.toggle('is-overflowing', hasOverflow);
        this.scrollRegionTarget.classList.toggle('has-left-content', hasLeftContent);
        this.scrollRegionTarget.classList.toggle('has-right-content', hasRightContent);
    }
}